import { render, staticRenderFns } from "./product-modify.vue?vue&type=template&id=0c1f39ca&scoped=true"
import script from "./product-modify.vue?vue&type=script&lang=js"
export * from "./product-modify.vue?vue&type=script&lang=js"
import style0 from "./product-modify.vue?vue&type=style&index=0&id=0c1f39ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f39ca",
  null
  
)

export default component.exports